import React from 'react';
export function Approach() {
  const questions = ['Is this business really worth buying?', 'What are the hidden costs?', 'How much capital will be needed after purchase?', 'How long can it take to reach break-even?', 'What services should be included?', 'What team is required?', 'What marketing strategy can bring clients?', 'What risks should be checked before signing?'];
  return <section id="approach" className="py-24 bg-white" data-id="element-17">
      <div className="max-w-7xl mx-auto px-6" data-id="element-18">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-19">
          <h2 className="text-sm font-sans font-semibold tracking-[0.2em] text-gold uppercase mb-4" data-id="element-20">
            Our Approach
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-21">
            Clarity Before You Invest
          </h3>
          <p className="text-charcoal-light text-lg font-light leading-relaxed" data-id="element-22">
            We combine beauty industry expertise, business strategy, financial
            planning and operational experience in the UAE market to answer your
            most critical questions.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-23">
          {questions.map((q, i) => <div key={i} className="bg-cream p-6 border border-charcoal/5 flex items-center justify-center text-center min-h-[120px]" data-id="element-24">
              <p className="font-serif text-lg leading-snug" data-id="element-25">{q}</p>
            </div>)}
        </div>
      </div>
    </section>;
}